import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormArray, FormGroup} from '@angular/forms';
import {FromShipping, Shipping, SiteSummary} from '../../models/shipping';
import {GetShippingFormsService} from '../../services/get-shipping-forms.service';
import {Observable, Subscription} from 'rxjs';
import * as fromShipping from '../../reducers';
import {select, Store} from '@ngrx/store';
import {AddShippingAction} from '../../actions/shipping-add';
import {LoadShippingAction, ShippingClearAction} from '../../actions/shipping-load';
import {debounceTime, distinctUntilChanged, skipWhile} from 'rxjs/operators';
import {ShippingMapperService} from '../../services/shipping-mapper.service';
import {LoadSiteSummariesClearAction} from '../../actions/site-summaries';
import { Location } from '@angular/common';
import {ShippingsContextService} from '../../../site/services/shippings-context.service';
import {Order} from '../../../order/models/order';
import * as fromOrder from '../../../order/reducers';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {Address, AddressSummaries} from '../../../shared/models/address';
import * as moment from 'moment';
import {DhlMapperService} from '../../../order/services/get-config-dhl-validation.service';
import {DHLService} from '../../../order/services/dhl-validation.service';
import {FooterDetails} from '../../../order/models/footer-extra-info';
import {ValidatedAddressDHLAction} from '../../../order/actions/dhl-validation-address';
import {ValidatedAddressShippingDHLAction} from '../../../order/actions/dhl-validation-address-shipping';

@Component({
  selector: 'storever-shipping-detail',
  templateUrl: './shipping-detail.component.html',
  styleUrls: ['./shipping-detail.component.scss']
})
export class ShippingDetailComponent implements OnInit , OnDestroy {
  form: FormGroup;
  isLoading: boolean;
  shippingForm: FromShipping;
  dhlValidation: boolean;
  siteSummaries$: Observable<SiteSummary>;
  addressSummaries$: Observable<AddressSummaries []>;
  shipping$: Observable<Shipping>;
  private sub$: Subscription;
  private subscriptions = [];
  order$: Observable<Order>;
  isShipping: boolean;
  dhlResult: FooterDetails[];

  dataContext: {context: string, clientId: string, siteId: string, shippingId: string};

  get title(): string {
    return this.activatedRoute.snapshot.routeConfig.data.title;
  }

  get isEdit(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail/:shippingId'
      || (this.dataContext && this.dataContext.shippingId && this.dataContext.shippingId.length > 0)
      || (this.activatedRoute.snapshot.routeConfig.path === 'detail/:id' && this.router.url.search('order') !== -1);
  }

  get isOrderEdit(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail/:id';
  }
  get isAdd(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path.includes('add');
  }
  get isSiteShippingEdit(): boolean {
    return this.dataContext && this.dataContext.shippingId && this.dataContext.shippingId.length > 0
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private activatedRoute: ActivatedRoute,
              private store: Store<fromShipping.AppState>,
              private storeOrder: Store<fromOrder.AppState>,
              private shippingMapperService: ShippingMapperService,
              private getFormsService: GetShippingFormsService,
              private location: Location,
              private router: Router,
              private dhlMapperService: DhlMapperService,
              private dhlService: DHLService,
              private shippingsContextService: ShippingsContextService) {
    this.dhlValidation = null;
    this.dhlResult = [];
    this.dhlServiceResponse();
    this.addressSummaries$ = this.store.pipe(select(fromShipping.selectors.getAddressSummaries));
  }


  ngOnInit(): void {
    this.isLoading = false;
    window.scroll(0, 0);
    this.form = this.getFormsService.getShipping();
    this.changeForDhlValidation();
    this.store.dispatch(new ShippingClearAction());
    this.store.dispatch(new LoadSiteSummariesClearAction());
    this.order$ = this.storeOrder.pipe(select(fromOrder.selectors.getOrder));
    this.loadData();
    this.clearDhlMessage();
  }
  changeForDhlValidation(): void {
    if ( this.form) {
      this.form.get(['address']).valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(value => {
        if (value) {
          this.updateFormDhlMessage(true, 'Site');
          this.dispatchValidationDhl();
        }
      });
    }

  }
  dispatchValidationDhl(): void {
    const value = this.form.getRawValue();
    if (
      value.address.city &&
      value.address.zip &&
      value.address.countryForm.name) {
        this.store.dispatch(new ValidatedAddressDHLAction({
          'address': value.address,
          'expeditionDate': moment(new Date()).add(7, 'days').format('YYYY-MM-DD') ,
          'type': value.address.addressType
        }));

    }
  }
  dhlServiceResponse(): void {
    this.sub$ = this.dhlService.getResponse().subscribe((message) => {
      this.dhlValidation = null;
      if (this.form) {
        if (message) {
          this.dhlMapperService.DBToVue(message);
          if (this.dhlMapperService.getDhlDeliveryDate()) {
            this.updateFormDhlMessage(false, 'dispatch');
            this.dhlValidation = true;

            // TODO: Transformer la verification adresse chez DHL en service
            if (this.dhlMapperService.getDhlAddressType() === 'Site') {
              this.updateFormDhlMessage(false, 'Site');
              this.dhlResult[0] = {
                icon: 'fa fa-check',
                color: 'green',
                message: (this.dhlResult[1] && this.dhlResult[1].color !== 'red') ? 'DHL_VALIDATION_OK_WITHOUT_DATE_SHIPPING' : 'DHL_VALIDATION_OK_SITE_SHIPPING',
                extraData: (
                  this.dhlResult[1] && this.dhlResult[1].color !== 'red') ? null : null
              }
            }
          } else {
            this.dhlValidation = true;
            if (this.dhlMapperService.getDhlAddressType() === 'Site') {
              this.updateFormDhlMessage(true, 'Site');
              this.dhlResult[0] = {
                icon: 'fa fa-ban',
                color: 'red',
                message: 'DHL_VALIDATION_ERROR_SHIPPING',
                extraData: this.dhlMapperService.getDhlMessageError()
              }
            }
          }
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }
  clearDhlMessage(): void {
    this.dhlResult = null;
    this.dhlValidation = null;
    this.dhlResult = [];
    // this.dhlResult = { icon: null, color: null, message: null, extraData: null };
  }
  updateFormDhlMessage(error: boolean, type: string): void {
    if (this.form) {
        if (!error) {
          this.form.get(['address']).setErrors(null);
        } else {
          this.form.get(['address']).setErrors({ required: true });
        }
    }
  }


  loadData(): void {
    this.isShipping = true;
    if (this.isEdit) {
      if (this.dataContext && this.dataContext.shippingId) {
        this.store.dispatch(new LoadShippingAction(this.dataContext.shippingId));
      } else if (this.isOrderEdit) {
        this.sub$ = this.order$.pipe(
          skipWhile(o => o === null)
        ).subscribe((order: Order) => {
          if (order) {
            if (order.shippingInfo && order.shippingInfo.uuid) {
              this.store.dispatch(new LoadShippingAction(order.shippingInfo.uuid));
            } else {
              this.isShipping = false;
            }
          }
        });
        this.subscriptions.push(this.sub$);
      } else {
        this.store.dispatch(new LoadShippingAction(this.activatedRoute.snapshot.paramMap.get('shippingId')));
      }
    }
    this.siteSummaries$ =  this.store.pipe(select(fromShipping.selectors.getSiteSummaries));
    this.addressSummaries$ = this.store.pipe(select(fromShipping.selectors.getAddressSummaries));
    this.shipping$ = this.store.pipe(select(fromShipping.selectors.getShipping));
    this.sub$ = this.shipping$.pipe(
      skipWhile(o => o === null)
    ).subscribe((shipping: Shipping) => {
      if (shipping) {
        this.patchForm(shipping);
        this.form.disable();
        this.isLoading = false;
        this.form.get(['misc', 'commentsForm', 'comments']).reset();
      }
    });
    this.subscriptions.push(this.sub$);

  }

  patchForm(value: Shipping): void {
    if (this.form) {
      this.shippingForm = this.shippingMapperService.dbToForm(value);
      this.form.patchValue(this.shippingForm);
      this.form.get('address').patchValue(this.shippingForm.address);
      this.form.get(['address', 'countryForm', 'name']).patchValue(this.shippingForm.address.country);
      this.form.get('contact').patchValue(this.shippingForm.contact);
    }

  }

  save(value: boolean, form: FormGroup): void {
    let path: string[];
    if (this.dataContext) {
      const clientId = this.dataContext.clientId;
      const siteId = this.dataContext.siteId;
      if (clientId && siteId)   {
        this.store.dispatch(new AddShippingAction({data: form.getRawValue()}));
        this.shippingsContextService.sendContext({context: 'Shippings', clientId: null, siteId: null, shippingId: null});
        this.router.navigate(['/', clientId, 'sites', 'detail', siteId], {fragment: 'Shippings'});
      }
    } else {
      path = ['/shippings/list'];
      this.store.dispatch(new AddShippingAction({data: form.getRawValue()}));
      this.router.navigate(path);

    }
  }

  resetForm(form: FormGroup): void  {
    this.form.reset();
    this.clearDhlMessage();
  }

  cancel(): void  {
    if (this.dataContext) {
      const clientId = this.dataContext.clientId;
      const siteId = this.dataContext.siteId;
      if (clientId && siteId) {
        this.shippingsContextService.sendContext({context: 'Shippings', clientId: null, siteId: null, shippingId: null});
        this.router.navigate(['/', clientId, 'sites', 'detail', siteId], {fragment: 'Shippings'})
      }
    } else {
      this.location.back();
    }

  }

  ngOnDestroy(): void {
    this.clearDhlMessage();
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
    this.store.dispatch(new ShippingClearAction());
  }

  actionButton(type: string): void {
  }
}
